import createSvgIcon from "./utils/create_icon"

const CartOutline = createSvgIcon(<><g fill="currentColor"><path clipRule="evenodd" d="M4 3a1 1 0 0 0 0 2h2v9a3 3 0 0 0 3 3h10a1 1 0 1 0 0-2H9a1 1 0 0 1-1-1v-1h9a4 4 0 0 0 4-4V7a1 1 0 0 0-1-1H8V5a2 2 0 0 0-2-2zm4 5v3h9a2 2 0 0 0 2-2V8z" fillRule="evenodd" /><path d="M10 19.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm7.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" /></g></>, "CartOutline")
export default CartOutline
